import { NgModule } from "@angular/core";
import { S25SimpleCollapseComponent } from "./s25.simple.collapse.component";

/** @deprecated use S25SimpleCollapseComponent instead */
@NgModule({
    imports: [S25SimpleCollapseComponent],
    providers: [S25SimpleCollapseComponent],
    exports: [S25SimpleCollapseComponent],
})
export class S25SimpleCollapseModule {
    constructor() {}
}
